import { PasswordStrength } from '../constants';
/**
 * Password Strength is determined by the following criteria
 *
 * Fair Strength Password
 *  - Must be 8-50 characters (extended from 32)
 *  - Must include 1 letter and 1 number
 *
 * Medium Strength Password
 *  - Must be 8-50 characters (extended from 32)
 *  - Must include 1 letter and 1 number
 *  - Must include a capital letter and a lower-case letter
 *  - Must include a special character ! @ # $ % ^ & * ( ) - ?
 *
 * Strong Strength Password
 *  - Must be 15-50 characters
 *  - Must include 1 letter and 1 number
 *  - Special characters are not required
 */
export const determinePasswordStrength = (password) => {
    const { length } = password;
    const containsLowercaseLetter = /[a-z]/g.test(password);
    const containsUppercaseLetter = /[A-Z]/g.test(password);
    const containsLetter = containsLowercaseLetter || containsUppercaseLetter;
    const containsNumber = /[0-9]/g.test(password);
    const containsSpecialChar = /[!@#$%^&*()\-?]/g.test(password);
    // If the password exceeds 50 characters we should clear the result
    if (length > 50) {
        return PasswordStrength.None;
    }
    // Strong
    if (length >= 15 && containsLetter && containsNumber) {
        return PasswordStrength.Strong;
    }
    // Medium
    if (length >= 8 &&
        containsUppercaseLetter &&
        containsLowercaseLetter &&
        containsNumber &&
        containsSpecialChar) {
        return PasswordStrength.Medium;
    }
    // Fair
    if (length >= 8 && containsLetter && containsNumber) {
        return PasswordStrength.Fair;
    }
    return PasswordStrength.None;
};
//# sourceMappingURL=determinePasswordStrength.js.map